import React from 'react';
import DownloadLink from '@hubins/components/DownloadLink';
import PreviewLink from '@hubins/components/PreviewLink';
import './index.scss';

type Props = {
  id: string,
  title: string,
}

const FormDocument = ({id, title}: Props) => {

  const url = `/v1/file/terms/${id}/download`;

  return (
    <div className="form-document">
      <p className="form-document__title">{title}</p>
      <div className="form-document__actions">
        <DownloadLink
          onlyIcon={true}
          hideName={true}
          name={title}
          url={url}
          icon="Common File Stack by Streamlinehq"
        />
        <PreviewLink
          onlyIcon={true}
          hideName={true}
          name={title}
          url={url}
          icon="View 1 by Streamlinehq"
        />
      </div>
    </div>
  )
};

export default FormDocument;